module.exports = __webpack_public_path__ + "img/主要功能-开放平台3.5209a2a3.png";